/*
  an-price-slider — deslizador de precio de doble control para las facetas de Dawn.
  Envuelve los inputs de texto nativos (De/Hasta) que Dawn envía por formulario y
  añade un slider visual encima. El slider escribe ENTEROS simples en esos inputs
  (Shopify los acepta en filter.v.price.gte/lte) y deja que la maquinaria de Dawn
  (FacetFiltersForm, input + debounce) haga el fetch/refresco de la rejilla.

  Es un custom element => se reinicializa solo cuando facets.js reemplaza el
  innerHTML de la faceta por AJAX. Ver snippets/price-facet.liquid.
*/
(function () {
  if (customElements.get('an-price-slider')) return;

  var fmt;
  try {
    fmt = new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      maximumFractionDigits: 0,
    });
  } catch (e) {
    fmt = { format: function (n) { return '$' + n; } };
  }

  function parseMoney(str) {
    if (str === null || str === undefined) return NaN;
    var s = String(str).trim();
    if (s === '') return NaN;
    // "40.000,00" -> quitar separadores de miles (.) y coma decimal -> 40000
    var cleaned = s.replace(/[^\d.,]/g, '').replace(/\./g, '').replace(',', '.');
    var n = parseFloat(cleaned);
    return isNaN(n) ? NaN : Math.round(n);
  }

  class AnPriceSlider extends HTMLElement {
    connectedCallback() {
      if (this.mounted) return;
      this.mounted = true;

      this.rangeMin = parseInt(this.dataset.min || '0', 10) || 0;
      this.rangeMax = parseInt(this.dataset.max || '0', 10) || 0;
      if (this.rangeMax <= this.rangeMin) this.rangeMax = this.rangeMin + 1;

      var span = this.rangeMax - this.rangeMin;
      this.step = span > 200000 ? 1000 : span > 2000 ? 100 : span > 200 ? 10 : 1;
      // Tope de UI redondeado hacia arriba al paso, para que el máximo real sea alcanzable.
      this.uiMax = Math.ceil(this.rangeMax / this.step) * this.step;

      this.thumbMin = this.querySelector('[data-an-price-thumb="min"]');
      this.thumbMax = this.querySelector('[data-an-price-thumb="max"]');
      this.fill = this.querySelector('[data-an-price-fill]');
      this.outMin = this.querySelector('[data-an-price-out="min"]');
      this.outMax = this.querySelector('[data-an-price-out="max"]');
      this.inputMin = this.querySelector('[data-an-price-input="min"]');
      this.inputMax = this.querySelector('[data-an-price-input="max"]');

      if (!this.thumbMin || !this.thumbMax || !this.inputMin || !this.inputMax) return;

      [this.thumbMin, this.thumbMax].forEach((t) => {
        t.min = this.rangeMin;
        t.max = this.uiMax;
        t.step = this.step;
      });

      var curMin = parseMoney(this.inputMin.value);
      var curMax = parseMoney(this.inputMax.value);
      this.thumbMin.value = isNaN(curMin) ? this.rangeMin : Math.max(this.rangeMin, curMin);
      this.thumbMax.value = isNaN(curMax) ? this.uiMax : Math.min(this.uiMax, curMax);

      this.thumbMin.addEventListener('input', () => this.onInput('min'));
      this.thumbMax.addEventListener('input', () => this.onInput('max'));

      this.render();
    }

    onInput(which) {
      var mn = parseInt(this.thumbMin.value, 10);
      var mx = parseInt(this.thumbMax.value, 10);
      var gap = this.step;

      if (which === 'min') {
        if (mn > mx - gap) {
          mn = Math.max(this.rangeMin, mx - gap);
          this.thumbMin.value = mn;
        }
      } else {
        if (mx < mn + gap) {
          mx = Math.min(this.uiMax, mn + gap);
          this.thumbMax.value = mx;
        }
      }

      // Escribe enteros simples en los inputs de texto (fuente de verdad del envío).
      // Vacío si está en el extremo => sin límite por ese lado.
      this.inputMin.value = mn <= this.rangeMin ? '' : String(mn);
      this.inputMax.value = mx >= this.rangeMax ? '' : String(mx);

      // Dispara el envío de Dawn (form escucha 'input' con debounce).
      this.inputMin.dispatchEvent(new Event('input', { bubbles: true }));

      this.render();
    }

    render() {
      var mn = parseInt(this.thumbMin.value, 10);
      var mx = parseInt(this.thumbMax.value, 10);
      var span = this.uiMax - this.rangeMin || 1;
      var p1 = ((mn - this.rangeMin) / span) * 100;
      var p2 = ((mx - this.rangeMin) / span) * 100;

      if (this.fill) {
        this.fill.style.left = p1 + '%';
        this.fill.style.right = 100 - p2 + '%';
      }
      // En el tope mostramos el máximo REAL (no el redondeado de UI).
      var displayMax = mx >= this.rangeMax ? this.rangeMax : mx;
      if (this.outMin) this.outMin.textContent = fmt.format(mn);
      if (this.outMax) this.outMax.textContent = fmt.format(displayMax);

      // Cuando el control mínimo llega arriba, súbelo por encima para poder arrastrarlo de vuelta.
      this.thumbMin.style.zIndex = p1 > 90 ? 6 : 4;
    }
  }

  customElements.define('an-price-slider', AnPriceSlider);

  // Puente del select de orden móvil (barra propia) hacia el #SortBy real de Dawn.
  // Delegado en document para que funcione también tras re-render AJAX de las facetas.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.hasAttribute || !t.hasAttribute('data-an-sort-mirror')) return;
    var real = document.getElementById('SortBy');
    if (!real) return;
    real.value = t.value;
    real.dispatchEvent(new Event('input', { bubbles: true }));
  });
})();
